if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0; 
(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    //tabs sections
	const tabLinks = document.querySelectorAll('ul.js-tabs-menu li a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].classList.remove('active');
			}
			this.classList.add('active');
			return false;
		}
	}

    //animations below
    setTimeout(function(){
        document.getElementsByClassName('top-content-home__uvp')[0].classList.add('show-object');
    }, 1000); 

	const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();

    //fancybox
    $('.fancycopy-link').fancybox({
        wrapCSS : 'fancycopy-popup',
        baseClass : 'fancycopy-popup',
        padding: 0,
        helpers: {
            overlay: {
              locked: false
            }
        }
    });
    

    const formSingUp = document.querySelectorAll('#email-signup')

    if(formSingUp){
        formSingUp.forEach((singleForm) => {
            singleForm.querySelector("input[name='subscribe']").classList.remove('required');
            singleForm.querySelector("input[name='subscribe']").checked = true;
        })
    }

})();

$(document).ready(function () {
    // Center top content @ cleanliness
    if (location.pathname.indexOf('/cleanliness') > -1){
        $('.intro-copy h1, .intro-copy p').css('max-width', '100%');
        $('.intro-copy h1, .intro-copy p').css('text-align', 'center')
    }
});